<template>
  <div class="text-body text-black-2 inline-flex place-items-center gap-2">
    <template v-if="editable">
      <RfActionSuccess class="h-5! w-5! shrink-0 rounded-full" /> Yes
    </template>
    <template v-else> <RfActionError class="h-5! w-5! shrink-0 rounded-full" /> No </template>
  </div>
</template>

<script setup>
import RfActionError from "@/components/statuses/RfActionError.vue";
import RfActionSuccess from "@/components/statuses/RfActionSuccess.vue";

defineProps({ editable: { type: Boolean, default: false } });
</script>
